import Cookie from 'js-cookie'
import { RECEIVE_USER_INFO, REQUEST_USER_INFO, SET_USER_AUTH, RECEIVE_USER_PERM } from '../constants'
import { UserAction } from '../actions/user'

const user = (state: object = {}, action: UserAction) => {
  switch (action.type) {
    case SET_USER_AUTH:
      Cookie.set('bm_token', action.token)
      Cookie.set('bm_user_id', action.id)
      return Object.assign({}, state, {
        token: action.token
      })
    case REQUEST_USER_INFO:
      return state
    case RECEIVE_USER_INFO:
      return Object.assign({}, state, action)
    case RECEIVE_USER_PERM:
      return Object.assign({}, state, {
        perm: action.perm
      })
    default:
      return state
  }
}
export default user



// WEBPACK FOOTER //
// ./src/reducers/user.tsx